import { render, staticRenderFns } from "./QuestionaireFragenModal.vue?vue&type=template&id=2fdb990e&"
import script from "./QuestionaireFragenModal.vue?vue&type=script&lang=js&"
export * from "./QuestionaireFragenModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionaireFragenModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports